require('./base').setActionDefaults(require('../actions/gesture'));
